import React from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const baseFeatures = ['6 Tomos PDF completos', 'Bono 1 — Planificador Express', 'Bono 2 — Checklist Pre-Clase Pro', 'Bono 3 — Pack de Frases Pro', 'Acceso inmediato'];
  const completeFeatures = [...baseFeatures, '🔥 S.R.I. Sistema de Retención Infinita', '🔥 Protocolo Estratégico de 12 meses', '🔥 Plan de negocio del instructor autónomo'];
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-196">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-197">
        💰 Elige Tu Pack
      </h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-8" data-id="element-198">
        {/* Base Pack */}
        <div className="bg-gradient-card border border-brand-border rounded-3xl p-8 shadow-card hover:shadow-violet-glow transition-all" data-id="element-199">
          <div className="flex items-center gap-2 mb-4" data-id="element-200">
            <span className="text-3xl" data-id="element-201">🥉</span>
            <div data-id="element-202">
              <h3 className="font-heading text-xl font-bold text-brand-subtitle tracking-wide" data-id="element-203">
                PACK BASE
              </h3>
              <div className="font-heading text-2xl font-black text-brand-title" data-id="element-204">
                13,99€
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-205">
            El sistema completo para empezar a enseñar mejor hoy
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-206">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-207">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-border/50" data-id="element-208">
              <thead data-id="element-209">
                <tr className="border-b border-brand-border/50" data-id="element-210">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-211">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-212">
                {baseFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-213">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-214">
                      <span className="text-green-400 shrink-0" data-id="element-215">✅</span>
                      <span data-id="element-216">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-217">
            <div className="font-body text-brand-textMuted text-sm mb-1" data-id="element-218">
              Valor real: 83,94€
            </div>
            <div className="font-heading text-4xl font-black text-brand-title mb-4" data-id="element-219">
              13,99€
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56520042512710:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Base', '13.99')} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-220">
            🚀 ¡QUIERO EL PACK BASE!
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-221">
            <div data-id="element-222">⚡ Acceso Inmediato</div>
            <div data-id="element-223">💳 Pago Único</div>
            <div data-id="element-224">🛡️ Garantía 7 Días</div>
          </div>
        </div>

        {/* Complete Pack */}
        <div className="bg-gradient-card border-2 border-brand-gold rounded-3xl p-8 shadow-gold-glow-lg relative transform md:-translate-y-4" data-id="element-225">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-gold text-brand-bg font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-gold-glow tracking-wider" data-id="element-226">
            ⭐ MÁS POPULAR
          </div>

          <div className="flex items-center gap-2 mb-4" data-id="element-227">
            <span className="text-3xl" data-id="element-228">🥇</span>
            <div data-id="element-229">
              <h3 className="font-heading text-xl font-bold text-brand-subtitle tracking-wide" data-id="element-230">
                PACK COMPLETO
              </h3>
              <div className="font-heading text-2xl font-black text-brand-title" data-id="element-231">
                19,99€
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-232">
            Todo lo anterior + el Sistema de Retención Infinita S.R.I.
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-233">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-234">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-gold/30" data-id="element-235">
              <thead data-id="element-236">
                <tr className="border-b border-brand-gold/30" data-id="element-237">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-238">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-239">
                {completeFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-240">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-241">
                      <span className="text-green-400 shrink-0" data-id="element-242">✅</span>
                      <span data-id="element-243">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-244">
            <div className="font-body text-brand-textMuted text-sm mb-1" data-id="element-245">
              Valor real: 140,94€
            </div>
            <div className="font-heading text-4xl font-black text-brand-title mb-4" data-id="element-246">
              19,99€
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56520077934918:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Completo', '19.99')} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-247">
            🚀 ¡QUIERO EL PACK COMPLETO!
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-248">
            <div data-id="element-249">⚡ Acceso Inmediato</div>
            <div data-id="element-250">💳 Pago Único</div>
            <div data-id="element-251">🛡️ Garantía 7 Días</div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card border border-brand-borderGlow/20 rounded-2xl p-6 max-w-2xl mx-auto text-center shadow-violet-glow" data-id="element-252">
        <p className="font-body text-brand-subtitle font-medium" data-id="element-253">
          💡 Por solo 6€ más, obtienes el sistema completo de retención y
          escalabilidad. La mayoría elige este.
        </p>
      </div>
    </Section>;
}